"use strict";
var c, l;
function R() {
  if (l) return c;
  l = 1;
  var y = "Function.prototype.bind called on incompatible ", g = Object.prototype.toString, h = Math.max, s = "[object Function]", v = function(e, r) {
    for (var t = [], n = 0; n < e.length; n += 1)
      t[n] = e[n];
    for (var o = 0; o < r.length; o += 1)
      t[o + e.length] = r[o];
    return t;
  }, m = function(e, r) {
    for (var t = [], n = r, o = 0; n < e.length; n += 1, o += 1)
      t[o] = e[n];
    return t;
  }, b = function(a, e) {
    for (var r = "", t = 0; t < a.length; t += 1)
      r += a[t], t + 1 < a.length && (r += e);
    return r;
  };
  return c = function(e) {
    var r = this;
    if (typeof r != "function" || g.apply(r) !== s)
      throw new TypeError(y + r);
    for (var t = m(arguments, 1), n, o = function() {
      if (this instanceof n) {
        var i = r.apply(
          this,
          v(t, arguments)
        );
        return Object(i) === i ? i : this;
      }
      return r.apply(
        e,
        v(t, arguments)
      );
    }, d = h(0, r.length - t.length), f = [], u = 0; u < d; u++)
      f[u] = "$" + u;
    if (n = Function("binder", "return function (" + b(f, ",") + "){ return binder.apply(this,arguments); }")(o), r.prototype) {
      var p = function() {
      };
      p.prototype = r.prototype, n.prototype = new p(), p.prototype = null;
    }
    return n;
  }, c;
}
export {
  R as __require
};
//# sourceMappingURL=index.es405.js.map
